var map = {
	"./add-keywords-modal/AddKeywordsModal.vue": "aQ1J",
	"./add-project-modal/AddProjectModal.vue": "7ex9",
	"./add-tags-modal/AddTagsModal.vue": "X67b",
	"./confirm-modal/ConfirmModal.vue": "l9rc",
	"./edit-project-modal/EditProjectModal.vue": "9/lZ",
	"./insights-item/InsightsItem.vue": "Md3G",
	"./loader/Loader.vue": "Gy3H",
	"./tag-multiple-select/TagMultipleSelect.vue": "wQwe",
	"./toolbar-pager/ToolbarPagerComponent.vue": "AF4a",
	"./toolbar/ToolbarComponent.vue": "phma"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "px8V";


//////////////////
// WEBPACK FOOTER
// ./src/components [A-Z,a-z]\w+\.vue$
// module id = px8V
// module chunks = 19